import React from "react";

import "./App.scss";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Clock, MapPin } from "lucide-react";

import thumbnail from "../../assets/images/event.jpg";
import dvWalk from "../../assets/images/GalleryImages/image_54.jpg";

// Campaign card
function CampCard({ imageUrl, Time, Title, Location, Description }) {
  const navigate = useNavigate();

  return (
    <article className="campCard">
      <div
        className="topSection"
        style={{ backgroundImage: `url(${imageUrl})` }}
        role="img"
        aria-label={Title}
      >
        <div className="dateCon">
          <Clock aria-hidden="true" />
          <h3>{Time}</h3>
        </div>
      </div>

      <div className="middleSection">
        <h2>{Title}</h2>
        <p>{Description}</p>

        <div className="locationDiv">
          <MapPin aria-hidden="true" />
          <h3>{Location}</h3>
        </div>
      </div>

      <div className="bottomSection">
        <button
          type="button"
          onClick={() => {
            navigate(`/Donation?campaign=${encodeURIComponent(Title)}`);
          }}
        >
          DONATE NOW
          <span className="iconWrapper">
            <ChevronRight aria-hidden="true" />
          </span>
        </button>
      </div>
    </article>
  );
}

const campaigns = [
  {
    imageUrl: dvWalk,
    Time: "25th Nov, 2023",
    Title: "Domestic Violence Awareness Walk",
    Location: "Accra Central",
    Description:
      "ASK Ghana, in partnership with DOVSU, marched through Accra to raise awareness and speak out against domestic and gender-based violence.",
  },
  // TODO: add these once the client confirms the date and location
  // (the photos are in the Gallery, so just import one like dvWalk above):
  // { imageUrl: ..., Time: "", Title: "Health for Christmas", Location: "", Description: "" },
  // { imageUrl: ..., Time: "", Title: "Embrace Your Breasts", Location: "", Description: "" },
  // { imageUrl: ..., Time: "", Title: "International Literacy Day", Location: "", Description: "" },
  // { imageUrl: ..., Time: "", Title: "Women and Girls in Science Day", Location: "", Description: "" },
  {
    Time: "20th Dec, 2024",
    Title: "Special Needs",
    Location: "Cape Coast, Accra",
    Description:
      "Lorem Ipsum is simply dummy a of the printing and type setting industry Loreaim Ipsum has",
  },
  {
    Time: "1st May, 2025",
    Title: "Donation Drive",
    Location: "McCarthy Hill, Mallam",
    Description:
      "Lorem Ipsum is simply dummy a of the printing and type setting industry Loreaim Ipsum has",
  },
  {
    Time: "12th Dec, 2026",
    Title: "Children Education",
    Location: "Madina, Accra",
    Description:
      "Lorem Ipsum is simply dummy a of the printing and type setting industry Loreaim Ipsum has",
  },
];

function App() {
  return (
    <>
      <div className="Campaigns">
        <div className="overlay"></div>

        <div className="content">
          <Navbar />

          <div className="heroTitle">
            <h1>Campaigns</h1>
            <p>Join us in making a difference. Every donation counts.</p>
          </div>

          <div className="extra"></div>
        </div>
      </div>

      <div className="campaignWrapper">
        {campaigns.map((c) => (
          <CampCard key={c.Title} {...c} imageUrl={c.imageUrl || thumbnail} />
        ))}
      </div>

      {/* Footer was imported but never rendered; remove this line if you don't want it here */}
      <Footer />
    </>
  );
}

export default App;